function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.29 6.11a.68.68 0 01-.68.68h-4.75a.68.68 0 01-.63-.42.65.65 0 01.15-.73l1.46-1.46a5.43 5.43 0 10-3.7 9.41 5.37 5.37 0 004.28-2.11.35.35 0 01.24-.13.41.41 0 01.27.1l1.45 1.46a.34.34 0 010 .46A8.15 8.15 0 118.11.02a8.24 8.24 0 015.61 2.25L15.1.9a.67.67 0 01.74-.15.69.69 0 01.41.63v4.75z"
});

var SvgPostalSubmit = function SvgPostalSubmit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 16.29 16.29"
  }, props), _ref);
};

export default SvgPostalSubmit;